import styled from "@emotion/styled";
import Button from "@mui/material/Button";

const CustomButton = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    borderRadius: '4px',
    lineHeight: 1.5,
    backgroundColor: '#004D99',
    borderColor: '#004D99',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        backgroundColor: '#E6F2FF',
        borderColor: '#E6F2FF',
        color: '#004D99',
        boxShadow: 'none',

    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: '#004D99',
        borderColor: '#004D99',
    },
    '&:focus': {
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
});

export default CustomButton;